import { Table as MuiTable } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import React from "react";
import { SxProps, Theme } from "@mui/material/styles";

interface Props {
  header: JSX.Element;
  body: JSX.Element;
  ref?: React.MutableRefObject<any>;
  type: "aggregate" | "portfo";
  tableSx?: SxProps<Theme>;
}

const Table: React.FC<Props> = ({ header, body, ref, tableSx }) => {
  return (
    <MuiTable
      stickyHeader
      className="relative min-h-[100px]"
      ref={ref}
      sx={tableSx}
    >
      <TableHead>{header}</TableHead>
      <TableBody>{body}</TableBody>
    </MuiTable>
  );
};

export default Table;
